module.exports = __webpack_public_path__ + "static/img/meecees_pictgrid12_980x870.389cd38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/meecees_pictgrid12_980x870.jpg
// module id = UHYP
// module chunks = 0